var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.candidates.length > 0)?_c('span',{staticClass:"candidate-counter",class:{ active: _vm.leftSidebar == 'compares' }},[_vm._v(_vm._s(_vm.candidates.length))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }